import React, { Suspense, lazy } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { Layout } from "./layouts";
import ScrollToTop from "./components/ScrollToTop";
import { LanguageProvider } from "./context/LanguageContext";
import { AuthProvider } from "./context/AuthContext";
import "./App.css";

const Home = lazy(() => import("./pages/Home"));
const AboutUs = lazy(() => import("./pages/AboutUs/AboutUs"));
const Projects = lazy(() => import("./pages/Projects/Projects"));
const AdminPanel = lazy(() => import("./pages/Admin/AdminPanel"));
const Policy = lazy(() => import("./pages/Policy/Policy"));
const Membership = lazy(() => import("./pages/Membership/Membership"));
const MembershipSignup = lazy(() => import("./pages/Membership/MembershipSignup"));
const MembershipUpgrade = lazy(() => import("./pages/Membership/MembershipUpgrade"));
const Profile = lazy(() => import("./pages/Profile/Profile"));
const News = lazy(() => import("./pages/News/News"));
const NewsDetail = lazy(() => import("./pages/News/NewsDetail"));
const Library = lazy(() => import("./pages/Library/Library"));
const LibraryReader = lazy(() => import("./pages/Library/LibraryReader"));
const Donate = lazy(() => import("./pages/Donate/Donate"));
const ForgotPasswordPage = lazy(() => import("./pages/Auth/ForgotPasswordPage"));
const ResetPasswordPage = lazy(() => import("./pages/Auth/ResetPasswordPage"));
const DeletedAccountPage = lazy(() => import("./pages/Auth/DeletedAccountPage"));

const RouteFallback = () => <div className="route-loading-shell" aria-hidden="true" />;

function App() {
  return (
    <LanguageProvider>
      <AuthProvider>
        <Router>
          <ScrollToTop />
          <div className="App">
            <Suspense fallback={<RouteFallback />}>
              <Routes>
                <Route
                  path="/"
                  element={
                    <Layout>
                      <Home />
                    </Layout>
                  }
                />
                <Route
                  path="/about-us"
                  element={
                    <Layout>
                      <AboutUs />
                    </Layout>
                  }
                />
                <Route
                  path="/projects"
                  element={
                    <Layout>
                      <Projects />
                    </Layout>
                  }
                />
                <Route
                  path="/policy"
                  element={
                    <Layout>
                      <Policy />
                    </Layout>
                  }
                />
                <Route
                  path="/membership"
                  element={
                    <Layout>
                      <Membership />
                    </Layout>
                  }
                />
                <Route
                  path="/membership/register"
                  element={
                    <Layout>
                      <MembershipSignup />
                    </Layout>
                  }
                />
                <Route
                  path="/membership/upgrade"
                  element={
                    <Layout>
                      <MembershipUpgrade />
                    </Layout>
                  }
                />
                <Route
                  path="/profile"
                  element={
                    <Layout>
                      <Profile />
                    </Layout>
                  }
                />
                <Route
                  path="/news"
                  element={
                    <Layout>
                      <News />
                    </Layout>
                  }
                />
                <Route
                  path="/news/:id"
                  element={
                    <Layout>
                      <NewsDetail />
                    </Layout>
                  }
                />
                <Route
                  path="/library"
                  element={
                    <Layout>
                      <Library />
                    </Layout>
                  }
                />
                <Route
                  path="/library/category/:categorySlug"
                  element={
                    <Layout>
                      <Library />
                    </Layout>
                  }
                />
                <Route
                  path="/library/read/:bookId"
                  element={
                    <Layout>
                      <LibraryReader />
                    </Layout>
                  }
                />
                <Route
                  path="/donate"
                  element={
                    <Layout>
                      <Donate />
                    </Layout>
                  }
                />
                <Route
                  path="/forgot-password"
                  element={
                    <Layout>
                      <ForgotPasswordPage />
                    </Layout>
                  }
                />
                <Route
                  path="/reset-password"
                  element={
                    <Layout>
                      <ResetPasswordPage />
                    </Layout>
                  }
                />
                <Route
                  path="/account-deleted"
                  element={
                    <Layout>
                      <DeletedAccountPage />
                    </Layout>
                  }
                />
                <Route path="/v1/api/controlls/admin" element={<AdminPanel />} />
              </Routes>
            </Suspense>
          </div>
        </Router>
      </AuthProvider>
    </LanguageProvider>
  );
}

export default App;
